/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesRosterInvitationStatusSchema } from "./rosterInvitationStatusSchema.ts";
import { goodLuckCoreEntitiesRosterSchema } from "./rosterSchema.ts";
import { goodLuckCoreEntitiesTeamRoleSchema } from "./teamRoleSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesRosterInvitationSchema = z.object({
  id: z.string().nullish(),
  teamId: z.string().nullish(),
  invitedUserId: z.string().min(1),
  invitedByUserId: z.string().min(1),
  get status() {
    return goodLuckCoreEntitiesRosterInvitationStatusSchema.optional();
  },
  get role() {
    return goodLuckCoreEntitiesTeamRoleSchema.optional();
  },
  createdAt: z.optional(z.iso.datetime()),
  respondedAt: z.iso.datetime().nullish(),
  get team() {
    return goodLuckCoreEntitiesRosterSchema.optional();
  },
  get invitedUser() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  get invitedByUser() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
});
